import { render, staticRenderFns } from "./trend.vue?vue&type=template&id=f2299466&scoped=true&"
import script from "./trend.vue?vue&type=script&lang=js&"
export * from "./trend.vue?vue&type=script&lang=js&"
import style0 from "./trend.vue?vue&type=style&index=0&id=f2299466&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2299466",
  null
  
)

export default component.exports